/* STEP 7d (Add-on Card V1, 30-Oct-2026) — lane 7d-de: D-d the A9001 working hours "Not set" (7a OQ-13) and D-e the category
   of a specific-vouching sheet (7a OQ-14). EN + AR.
   Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_S7D_DE = {
  en: {
    s7dde: {
      hours: {
        notSet: "Not set",
        notSetHint: "No working hours are saved for this engagement. Enter both times and save to set them.",
        both: "Enter both the start and the end of the working hours (HH:MM), or leave both empty.",
      },
      specific: {
        allCategories: "All categories",
        allLines: "Category: all categories — every line of each named voucher is taken.",
        oneCategory: "Category: {cat} — only the lines of the named vouchers in this category are taken.",
        notInCategory: "No line in the chosen category: {list}",
      },
    },
    errors: {
      WORKING_HOURS_INCOMPLETE: "Enter both the start and the end of the working hours (HH:MM), or leave both empty to keep the saved working hours.",
    },
  },
  ar: {
    s7dde: {
      hours: {
        notSet: "غير محددة",
        notSetHint: "لم تُحفظ ساعات عمل لهذا الارتباط. أدخل الوقتين ثم احفظ لتحديدها.",
        both: "أدخل بداية ساعات العمل ونهايتها معاً (HH:MM)، أو اترك الحقلين فارغين.",
      },
      specific: {
        allCategories: "كل الفئات",
        allLines: "الفئة: كل الفئات — تُؤخذ كل أسطر كل قيد مذكور.",
        oneCategory: "الفئة: {cat} — تُؤخذ أسطر القيود المذكورة في هذه الفئة فقط.",
        notInCategory: "لا يوجد سطر في الفئة المختارة: {list}",
      },
    },
    errors: {
      WORKING_HOURS_INCOMPLETE: "أدخل بداية ساعات العمل ونهايتها معاً (HH:MM)، أو اترك الحقلين فارغين للإبقاء على ساعات العمل المحفوظة.",
    },
  },
};

export default I18N_S7D_DE;
